export enum StatusConfigKey {
    Gray = 'gray',
    Blue = 'blue',
    DarkGray = 'darkgray',
    Red = 'red',
    Green = 'green',
    Black = 'black',
    Yellow = 'yellow'
}
